<div class="bg-radiant">

  <div class="container">
    <div class="row vh-100">
      <div class="col-md-12 my-auto">
        <app-back-button
          [title]="'LANDING.PRIVACY_NOTICE.TITLE' | translate"
        ></app-back-button>
        <div class="row px-3">
          <div class="overflow-html" [innerHTML]="html | safeHtml"></div>
        </div>
      </div>
    </div>
  </div>
</div>
